<template>
  <component :is="current.component" v-if="current" v-bind="current.props" />
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'
import { useSheetStack } from '@/composables/sheet-stack'
import { SHEET_CONTEXT_KEY } from '@/composables/sheet-context'

const { current, isOpen, size, pop, clear } = useSheetStack()

const backButton = computed(() => {
  if (!current.value) {
    return false
  }
  if (current.value.meta?.backButton === false) {
    return false
  }
  return true
})

const title = computed(() => current.value?.meta?.title)

function handleBack() {
  if (size.value > 1) {
    pop()
  } else {
    clear()
  }
}

provide(SHEET_CONTEXT_KEY, { isOpen, backButton, title, handleBack })
</script>
